module.exports = __webpack_public_path__ + "static/media/empty.96426883.svg";